import { useMemo } from 'react';

import { isCurrentAccount } from '@shared/products-core';
import type { Account } from '@shared/products-types';

import { useProducts } from './useProducts';

type HookReturnType = ReturnType<typeof useProducts<Account>>;

export const useCurrentAccounts: () => HookReturnType = () => {
    const { isPending, error, refetch, products = [] } = useProducts();

    const [currentAccounts, currentAccountsById] = useMemo(() => {
        const filteredCurrentAccounts = products.filter(isCurrentAccount);
        return [
            filteredCurrentAccounts,
            filteredCurrentAccounts.reduce(
                (acc, current) => {
                    acc[current.id] = current;
                    return acc;
                },
                {} as HookReturnType['productsById'],
            ),
        ];
    }, [products]);

    return {
        isPending,
        error,
        refetch,
        products: currentAccounts,
        productsById: currentAccountsById,
    };
};
